<template>
	<div>
		<div>
			<el-form :inline="true" ref="queryForm" :model="queryForm">
				<el-form-item>
					<el-input v-model="queryForm.name" placeholder="律师姓名"></el-input>
				</el-form-item>
				<el-form-item style="width: 200px">
					<el-select v-model="queryForm.relationship_id" clearable  placeholder="请选择职位" filterable  >
						<el-option
							v-for="item in treeData"
							:key="item.id"
							:label="item.label"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-search" @click="list" type="danger">查询</el-button>
					<el-button icon="el-icon-plus" @click="add" type="primary">新增</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="tableData" :max-height="tableHeight">
			<el-table-column prop="name" label="律师姓名" min-width="150" :show-overflow-tooltip="true">
				<template slot-scope="scope">
						{{scope.row.name}}
				</template>
			</el-table-column>
			<el-table-column prop="services" label="律师简介" min-width="250">
				<template slot-scope="scope">
						{{scope.row.content}}
				</template>
			</el-table-column>
			<el-table-column prop="serviceNames" label="业务专长" min-width="150"></el-table-column>
			<el-table-column prop="educational_background" label="教育背景" min-width="150"></el-table-column>
			<el-table-column prop="image" label="图片" min-width="80">
				<template slot-scope="scope">
						<el-button
							v-if="scope.row.image"
							size="mini"
							type="primary"
							@click="showImage(scope.row.image)"
						>
							查看
						</el-button>
						<el-button
							v-else
							size="mini"
						>
							暂无
						</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="publish" label="上传时间" min-width="150"></el-table-column>
			<el-table-column align="center" label="操作" min-width="150">
				<template slot-scope="scope">
					<el-link @click="edit(scope.row)" :underline="false" type="primary" class="el-icon-edit-outline">编辑</el-link>
					<span style="display: inline-block;width: 20px;"></span>
					<el-link @click="del(scope.row)" :underline="false" type="danger" class="el-icon-delete">删除</el-link>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination background layout="total,prev, pager, next,jumper" @current-change="handleCurrentChange"
			:current-page="pageNo" :total="total">
		</el-pagination>
		<el-image-viewer v-if="showViewer" :on-close="closeImg" :url-list="srcList" />
	</div>
</template>

<script>
	import {queryTreeChannelByPid} from '@/api/channel'
	import ElImageViewer from "element-ui/packages/image/src/image-viewer";
	import {del,query} from "@/api/lawyer";
	import token from "@/token.js";

	export default {
		name: "Index",
		components: {
			ElImageViewer
		},
		data() {
			return {
				queryForm: {
					name: '',
					relationship_id:''
				},
				tableData: [],
				treeData: [],
				total: 0,
				pageNo: 1,
				defForm: {
					id:0,
					updateUserID: token.getUser().id,
					updateUserName: token.getUser().manager_username
				},
				showViewer:false,
				srcList:[],
				tableHeight:500
			}
		},
		
		mounted() {
			this.list()
			this.$nextTick(() => {
        const height = window.innerHeight
        this.tableHeight = height-230
      })
			queryTreeChannelByPid(26).then(data => {
				this.treeData = data.data
				console.log(this.treeData)
			}).catch(error => {

			})
		},
		methods: {
			closeImg(){
				this.showViewer = false
			},
			showImage(img){
				this.showViewer = true
				let srcList = []
				srcList.push(img)
				this.srcList = srcList
			},
			//改变当前页
			handleCurrentChange(val) {
				this.pageNo = val;
				this.list()
			},
			//查询栏目列表
			list() {
				let param = {
					name: this.queryForm.name,
					relationship_id: this.queryForm.relationship_id==null ? 0 : this.queryForm.relationship_id,
					page: this.pageNo,
					pageSize: 10,
				}
				query(param).then(data => {
					this.tableData = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			add() {
				this.$router.push('/adminIndex/lawyer_add')
			},
			edit(row) {
				this.$router.push({
					path: '/adminIndex/lawyer_edit',
					query: {
						obj: row
					}
				})
			},
			del(row) {
				this.defForm.id=row.id
			
				this.$confirm('确定要删除吗？', "提示", {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					del(this.defForm).then(data => {
						let totalPage = Math.ceil((this.total - 1) / 10); //15 是每页15条
						let pageNo = this.pageNo > totalPage ? totalPage : this.pageNo;
						this.pageNo = pageNo < 1 ? 1 : pageNo; //this.pageNo 当前页数
						this.list()
						this.$message.success("删除成功!")
					}).catch(error => {
						this.$message.error(error)
					})
				}).catch(() => {
			
				})
			},
		}
	}
</script>

<style scoped>

</style>
